module.exports = new __parcel__URL__("diogenes.842f2256.png").toString();